<app-layout-dialogheader1 [title]="title" [titlesub]="titlesub" mat-dialog-title></app-layout-dialogheader1>

<mat-dialog-content>

    <div class="sectionb">

        <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
        <app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
        <ng-container *ngIf="ismodal">
            <nav class="navbar navbar-expand-sm navbar-light bg-light justify-content-between section-header mb-2">
                <div><span class="navbar-brand mb-0 h1">Flight Basic Data</span></div>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <div class="navbar-nav ml-auto">

                        <ul class="nav navbar-nav ml-auto">
                            <li class="nav-item mr-1" *ngIf="uishowbtntoloadfiles">
                                <button btnCheckbox [ngModel]="uishowloadfilescomponentview"
                                    (click)="addfilesshowhide()" class="btn btn-outline-primary btn-sm "
                                    [ngClass]="[uishowloadfilescomponentview | frvisiblepipe]" role="button"> Add
                                    files</button>
                            </li>
                            <li class="nav-item mr-1">
                                <button matTooltip="Save data" type="button" class="btn btn-sm  btn-success "
                                    [disabled]="!myform.valid||submitted" (click)="saveModel()">
                                    <i class="far fa-save"></i> Save
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </ng-container>

        <form [formGroup]="myform" class="container-fluid" (ngSubmit)="saveModel()">
            <!-- id:{{flight?.flightid}} -->
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="name">Flight name</label>
                <div class="col-sm-9">
                    <input class="form-control form-control-sm" id="name" formControlName="name" type="text" required
                        placeholder="Enter flight name" [ngClass]="!myform.get('name').valid ? 'is-invalid' :'' ">
                    <div class="invalid-feedback" *ngIf="myform.get('name').hasError('required')">
                        Name is required
                    </div>
                    <div class="invalid-feedback" *ngIf="myform.get('name').hasError('minlength')">
                        Name must be at least 3 characters long.
                    </div>
                </div>
            </div>
            <h4>Flight Offset</h4>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="offset_x">*Offset X </label>
                <div class="col-sm-3">
                    <input class="form-control form-control-sm" id="offset_x" formControlName="offset_x" type="number"
                        required placeholder="Enter offset x of flight"
                        [ngClass]="!myform.get('offset_x').valid ? 'is-invalid' :'' ">
                    <div class="invalid-feedback" *ngIf="myform.get('offset_x').hasError('required')">
                        offset x is required
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="offset_y">*Offset Y </label>
                <div class="col-sm-3">
                    <input class="form-control form-control-sm" id="offset_y" formControlName="offset_y" type="number"
                        required placeholder="Enter offset y of flight"
                        [ngClass]="!myform.get('offset_y').valid ? 'is-invalid' :'' ">
                    <div class="invalid-feedback" *ngIf="myform.get('offset_y').hasError('required')">
                        offset y is required
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="offset_z">*Offset Z </label>
                <div class="col-sm-3">
                    <input class="form-control form-control-sm" id="offset_z" formControlName="offset_z" type="number"
                        required placeholder="Enter offset z of flight"
                        [ngClass]="!myform.get('offset_z').valid ? 'is-invalid' :'' ">
                    <div class="invalid-feedback" *ngIf="myform.get('offset_z').hasError('required')">
                        offset z is required
                    </div>
                </div>
            </div>
            <h4>Temperature ºC</h4>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="temperature_offset">Offset </label>
                <div class="col-sm-3">
                    <input class="form-control form-control-sm" id="temperature_offset"
                        formControlName="temperature_offset" type="number"
                        placeholder="Enter offset temperature of flight">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="temperature_low">Low </label>
                <div class="col-sm-3">
                    <input class="form-control form-control-sm" id="temperature_low" formControlName="temperature_low"
                        type="number" placeholder="Enter low temperature of flight"
                        [ngClass]="!myform.get('temperature_low').valid ? 'is-invalid' :'' ">
<!--                     <div class="invalid-feedback" *ngIf="myform.get('temperature_low').hasError('smallerthan')">
                        Flight low temperature must be smaller than higher temperature.
                    </div> -->
                </div>

            </div>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="temperature_high">High </label>
                <div class="col-sm-3">
                    <input class="form-control form-control-sm" id="temperature_high" formControlName="temperature_high"
                        type="number" placeholder="Enter high temperature of flight"
                        [ngClass]="!myform.get('temperature_high').valid ? 'is-invalid' :'' ">
<!--                     <div class="invalid-feedback" *ngIf="myform.get('temperature_high').hasError('greaterthan')">
                        Flight high temperature must be greater than lower temperature.
                    </div> -->
                </div>
            </div>
            <div class="alert text-danger" *ngIf="myform.get('temperature_low').hasError('smallerthan')">
                <i class="fas fa-exclamation-circle"></i>  Flight low temperature must be smaller than higher temperature.
            </div>
            <h4>Camera offset</h4>
            <p>Camera offset must be set in degrees </p>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="offset_camera_yaw">*YAW </label>
                <div class="col-sm-3">
                    <input class="form-control form-control-sm" id="offset_camera_yaw"
                        formControlName="offset_camera_yaw" type="number" required
                        placeholder="Enter offset x of flight"
                        [ngClass]="!myform.get('offset_camera_yaw').valid ? 'is-invalid' :'' ">
                    <div class="invalid-feedback" *ngIf="myform.get('offset_camera_yaw').hasError('required')">
                        offset is required
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="offset_camera_pitch">*PITCH </label>
                <div class="col-sm-3">
                    <input class="form-control form-control-sm" id="offset_camera_pitch"
                        formControlName="offset_camera_pitch" type="number" required
                        placeholder="Enter offset y of flight"
                        [ngClass]="!myform.get('offset_camera_pitch').valid ? 'is-invalid' :'' ">
                    <div class="invalid-feedback" *ngIf="myform.get('offset_camera_pitch').hasError('required')">
                        offset is required
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="offset_camera_roll">*ROLL </label>
                <div class="col-sm-3">
                    <input class="form-control form-control-sm" id="offset_camera_roll"
                        formControlName="offset_camera_roll" type="number" required
                        placeholder="Enter offset z of flight"
                        [ngClass]="!myform.get('offset_camera_roll').valid ? 'is-invalid' :'' ">
                    <div class="invalid-feedback" *ngIf="myform.get('offset_camera_roll').hasError('required')">
                        offset is required
                    </div>
                </div>
            </div>
            <div class="alert alert-info alert-with-icon" role="alert">
                <i class="fas fa-exclamation-circle" data-notify="icon"></i> Change Offset will change image projection.
            </div>

            <!--         <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="description">Description</label>
            <div class="col-sm-9">
                <textarea class="form-control form-control-sm" id="description" formControlName="description" rows="4"
                    placeholder="Description about flight..."></textarea>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label" for="flightDate">Flight Date </label>
            <div class="col-sm-2">
                {{flight?.info?.flightDate | date:'dd-MM-yyyy' }}
            </div>
        </div> -->
        </form>
    </div>

</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end">
    <button mat-raised-button type="button" (click)="saveModel()" [disabled]="!isvalid()||submitted"
        class="btn btn-success pull-right"><i class="far fa-save"></i> Save</button>
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>